import { createFileRoute } from '@tanstack/react-router'

import { OauthCallbackPage } from '../../../components/pages/oauth/oauth-callback-page.tsx'

/**
 * @todo Delete this route together with the page it mounts
 * @see https://linear.app/orus/issue/IND-1465
 */
export const Route = createFileRoute('/oauth/callback')({
  component: OauthCallbackPage,
})
